/**
 * Distance Converter for Florida's Scenic Byways
 * Converts kilometer distances to miles in the UI
 */

(function () {
	// Run when the DOM is fully loaded
	document.addEventListener('DOMContentLoaded', function () {
		// Initial conversion
		convertKilometersToMiles();

		// Set up an observer to catch dynamically added content
		setupDistanceObserver();
	});

	/**
	 * Convert kilometers to miles
	 * @param {number} km - Distance in kilometers
	 * @return {number} - Distance in miles
	 */
	function kmToMiles(km) {
		return km * 0.621371;
	}

	/**
	 * Format distance nicely
	 * @param {number} distance - The distance value
	 * @param {boolean} isMiles - Whether this is miles (true) or km (false)
	 * @return {string} - Formatted distance with unit
	 */
	function formatDistance(distance, isMiles = true) {
		const unit = isMiles ? 'mile' : 'km';
		const value = distance < 10 ? distance.toFixed(1) : Math.round(distance);
		const pluralUnit = value === 1 ? unit : unit + 's';
		return `${value} ${pluralUnit}`;
	}

	/**
	 * Find and convert all kilometer distances in the document
	 */
	function convertKilometersToMiles() {
		// Find text containing km distances
		const allElements = document.querySelectorAll('*');

		allElements.forEach(element => {
			// Skip script and style elements
			if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE') {
				return;
			}

			// Check if this element has direct text content (not just child elements)
			if (element.childNodes) {
				element.childNodes.forEach(node => {
					if (node.nodeType === Node.TEXT_NODE) {
						const text = node.textContent;
						if (text && text.includes('km')) {
							// Look for patterns like "X km" or "X kilometers"
							const kmPattern = /(\d+(?:\.\d+)?)\s*(?:km|kilometers)/gi;
							const newText = text.replace(kmPattern, (match, kmValue) => {
								const km = parseFloat(kmValue);
								const miles = kmToMiles(km);
								return formatDistance(miles);
							});

							if (text !== newText) {
								node.textContent = newText;
							}
						}
					}
				});
			}
		});
	}

	/**
	 * Set up a mutation observer to convert distances in dynamically added content
	 */
	function setupDistanceObserver() {
		// Create a new observer
		const observer = new MutationObserver(mutations => {
			let shouldConvert = false;

			// Check if any mutations contain km text
			mutations.forEach(mutation => {
				if (mutation.type === 'childList' && mutation.addedNodes.length) {
					mutation.addedNodes.forEach(node => {
						if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
							const nodeContent = node.nodeType === Node.TEXT_NODE ?
								node.textContent : node.innerHTML;
							if (nodeContent && nodeContent.includes('km')) {
								shouldConvert = true;
							}
						}
					});
				}
				else if (mutation.type === 'characterData') {
					const text = mutation.target.textContent;
					if (text && text.includes('km')) {
						shouldConvert = true;
					}
				}
			});

			// Only run the conversion if necessary
			if (shouldConvert) {
				convertKilometersToMiles();
			}
		});

		// Start observing
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			characterData: true
		});
	}
})();
